export function monthsToReach(
  goal: { savedCents: number; targetCents: number },
  monthlyContributionCents: number,
  monthlyRate = 0,
): number {
  let saved = goal.savedCents;
  if (saved >= goal.targetCents) return 0;
  if (monthlyContributionCents <= 0) return Infinity;
  let months = 0;
  while (saved < goal.targetCents && months < 600) {
    saved = saved * (1 + monthlyRate) + monthlyContributionCents;
    months++;
  }
  return months >= 600 ? Infinity : months;
}

export function monthsLabel(m: number): string {
  if (m === Infinity) return "—";
  if (m === 0) return "reached!";
  if (m < 1) return "< 1 month";
  if (m === 1) return "1 month";
  if (m < 12) return `${m} months`;
  const years = Math.floor(m / 12);
  const rem = m % 12;
  if (rem === 0) return `${years} ${years === 1 ? "year" : "years"}`;
  return `${years}y ${rem}m`;
}
